import { AddressEdit, Toast ,PickerGroup } from 'vant';
import { createApp } from 'vue';
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import Plugin from 'v-fit-columns';
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import App from './App.vue';
import { router } from './router';

const app = createApp(App);

//调试环境
// const env = 'debug';
//测试环境
// const env = 'dev';
//生产环境
const env = 'prod';

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

app.use(router);
app.use(AddressEdit);
app.use(Toast);
app.use(PickerGroup);
app.use(Plugin);
app.use(ElementPlus, {
    locale: zhCn,
  })
app.mount('#app');

export const globals = app.config.globalProperties
